import styled from 'styled-components';
import { fontStyle, baseStyles } from '../commonStyles';

const LABEL_STYLES = {
  font: 'literata',
  big: {
    size: 17,
    lh: 24,
  },
  default: {
    size: 16,
    lh: 24,
  },
  small: {
    size: 13,
    lh: 19,
  },
};

export const LabelStyledTag = styled.label`
  ${baseStyles}
  color: ${(p) => (p.color === 'dark' ? p.theme.colors.black : p.theme.colors.label)};
  ${fontStyle(LABEL_STYLES)}
`;
